<template>
  <div>
    <b-row class="mt-2">
      <b-col>
        <div class="flex justify-between w-full mb-2 items-center">
          <div class="lg:w-[30%]">
            <BInputGroup class="wrapper-search">
              <template #prepend>
                <BInputGroupText style="border-right: 0; background-color: white;">
                  <b-img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/search-normal-1.svg" />
                </BInputGroupText>
              </template>
              <BFormInput
                v-model="search"
                placeholder="Cari berdasarkan Nama/No HP"
                style="border-left: 0"
                class="pl-0 border-l-0"
                @input="handleSearchPartner"
              />
            </BInputGroup>
          </div>

          <div class="flex items-center gap-3">
            <b-dropdown
              id="dropdown-jenis-produk"
              variant="none"
              toggle-class="p-0 m-0 text-decoration-none border-0 shadow-none focus:outline-none focus:ring-0"
              no-caret
            >
              <template #button-content>
                <div class="border border-[#E2E8F0] hover:border-gray-400 transition-colors rounded-lg px-1 h-[38px] flex items-center gap-2 bg-white text-black min-w-[140px] justify-between text-[14px]">
                  <span class="font-medium">Jenis Produk</span>
                  <b-icon
                    icon="chevron-down"
                    class="text-black"
                    font-scale="0.8"
                  />
                </div>
              </template>
              <div class="p-2 custom-orange-checkbox [&_.custom-control-input:checked~.custom-control-label::before]:!bg-[#F97316] [&_.custom-control-input:checked~.custom-control-label::before]:!border-[#F97316]">
                <b-form-checkbox
                  v-for="(option, index) in typeProduct"
                  :key="index"
                  v-model="filter.typeProduct"
                  :name="`checkbox-prod-${index}`"
                  :value="option.value"
                  class="text-[13px] text-black mb-1"
                  @change="handleFilter(false)"
                >
                  {{ option.label }}
                </b-form-checkbox>
              </div>
            </b-dropdown>

            <b-dropdown
              id="dropdown-status"
              variant="none"
              toggle-class="p-0 m-0 text-decoration-none border-0 shadow-none focus:outline-none focus:ring-0"
              no-caret
            >
              <template #button-content>
                <div class="border border-[#E2E8F0] hover:border-gray-400 transition-colors rounded-lg px-1 h-[38px] flex items-center gap-2 bg-white text-black min-w-[120px] justify-between text-[14px]">
                  <span class="font-medium">Status</span>
                  <b-icon
                    icon="chevron-down"
                    class="text-black"
                    font-scale="0.8"
                  />
                </div>
              </template>
              <div class="p-2 custom-orange-checkbox [&_.custom-control-input:checked~.custom-control-label::before]:!bg-[#F97316] [&_.custom-control-input:checked~.custom-control-label::before]:!border-[#F97316]">
                <b-form-checkbox
                  v-for="(option, index) in status"
                  :key="index"
                  v-model="filter.status"
                  :name="`checkbox-stat-${index}`"
                  :value="option.value"
                  class="text-[13px] text-black mb-1"
                  @change="handleFilter(false)"
                >
                  {{ option.label }}
                </b-form-checkbox>
              </div>
            </b-dropdown>

            <div class="w-[1px] h-[24px] bg-[#E2E8F0] mx-1" />

            <b-button
              variant="primary"
              class="rounded-md px-4 py-1.5 flex items-center justify-center font-medium bg-[#F97316] border-[#F97316] hover:bg-[#EA580C] hover:border-[#EA580C] shadow-none"
              @click="handleDownload"
            >
              Download
            </b-button>
          </div>
        </div>
        <BOverlay
          :show="loading"
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <BTable
            id="scroll"
            ref="scroll"
            :items="items"
            :fields="fieldsPartnerTable"
            show-empty
            empty-text="Tidak ada data yang ditampilkan."
            responsive
            sticky-header="500px"
            class=""
            @scroll.native="handleScroll"
          >
            <template #cell(name)="data">
              <div>
                <div class="text-base">
                  {{ data.item.partner_name }}
                </div>
                <span class="text-xs mt-1 text-[#828282]">
                  {{ data.item.partner_email }}
                </span>
              </div>
            </template>
            <template #cell(partner_phone)="data">
              <div>
                <div class="text-base">
                  0{{ data.item.partner_phone }}
                </div>
              </div>
            </template>
            <template #cell(subscription)="data">
              <div>
                <div
                  :class="data.item.subscription === 'starter' ? 'bg-[#E9E9E9] text-[#626262]' : data.item.subscription === 'pro' ? 'bg-[#FFECE9] text-[#BA2405]' : data.item.subscription === 'basic' ? 'bg-[#FDF7E6] text-[#FF6A3A]' : ''"
                  class="rounded py-[3px] capitalize text-center w-[108px] px-1"
                >
                  {{ data.item.subscription }}
                </div>
                <div
                  v-show="data.item.subscription !== 'Verified' && data.item.subscription !== 'Registered'"
                  class="text-xs  mt-1 text-[#828282]"
                >
                  Exp: {{ DDMMYYYY(data.item.subscription_date) }}
                </div>
              </div>
            </template>
            <template #cell(last_active)="data">
              <div>
                <div
                  :class="data.item.status === 'Active' ? 'bg-[#DCF3EB] text-[#34A770]' : data.item.status === 'Inactive' ? 'bg-[#FDECEA] text-[#C62828]' : 'bg-[#F3F4F6] text-[#6B7280]'"
                  class=" px-1 py-[5px] rounded-md  text-center"
                >
                  {{ data.item.status }}
                </div>
              </div>
            </template>
            <template #cell(join_date)="data">
              <div>
                <div>
                  {{ DDMMYYYY(data.item.join_date) }}
                </div>
                <span class="text-xs mt-1 text-[#828282]">
                  {{ defineDate(data.item.join_date).time }} WIB
                </span>
              </div>
            </template>
            <template #cell(action)="data">
              <a
                class="text-primary font-semibold cursor-pointer"
                @click="$router.push({ name: 'partner-komchat-detail', params: { id: data.item.user_id, partnerData: data.item } })"
              >
                Details
              </a>
            </template>
          </BTable>
        </BOverlay>
      </b-col>
    </b-row>
    <ModalDownload />
  </div>
</template>

<script>
import { DDMMYYYY } from '@/libs/filterDate'
import { fieldsPartnerTable, status, typeProduct } from '../config'
import ModalDownload from './ModalDownload.vue'

export default {
  components: {
    ModalDownload,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldsPartnerTable,
      status,
      typeProduct,
      search: '',
      DDMMYYYY,
      isDropdown2Visible: false,
      filter: {
        typeProduct: [],
        status: [],
      },
    }
  },
  mounted() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true
      }
      if (bvEvent.componentId === 'dropdown-3') {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (bvEvent.componentId === 'dropdown-3') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  methods: {
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.$emit('getNextData')
      }
    },
    handleSearchPartner() {
      this.$emit('handleSearchPartner', this.search)
    },
    defineDate(dates) {
      if (!dates) return { date: '-', time: '-' }

      let dt
      if (dates instanceof Date) dt = dates
      else {
        dt = new Date(dates)
      }

      if (Number.isNaN(dt.getTime())) return { date: '-', time: '-' }

      const pad = n => String(n).padStart(2, '0')
      const year = dt.getFullYear()
      const month = pad(dt.getMonth() + 1)
      const day = pad(dt.getDate())
      const hours = pad(dt.getHours())
      const minutes = pad(dt.getMinutes())

      return { date: `${year}-${month}-${day}`, time: `${hours}:${minutes}` }
    },
    resetFilter() {
      this.filter.typeProduct = []
      this.filter.status = []
      this.$emit('handleSearchPartner')
    },
    handleFilter(reset) {
      if (reset) {
        this.filter.typeProduct = []
        this.filter.status = []
      }
      this.$emit('handleFilter', this.filter)
    },
    handleDownload() {
      this.$bvModal.show('modal-download-komchat')
    },
  },
}
</script>
